module.exports = __webpack_public_path__ + "static/media/lock-key-3-x@3x.c6e5fbdc.png";